export const pillars = ['Shock', 'Evidencia', 'Engaño', 'Confrontación', 'Decisión', 'Reconstrucción'];
export const tomos = [{
  n: 1,
  emoji: '📕',
  title: 'El Triaje Emocional (Día 1)',
  desc: 'Por qué tu cerebro no funciona bien en el shock y cómo detener la "hemorragia emocional" para sobrevivir las primeras horas sin explotar, suplicar ni tomar decisiones que después no tienen vuelta atrás.'
}, {
  n: 2,
  emoji: '📗',
  title: 'Blindaje Digital y Evidencias (Día 2)',
  desc: 'Cómo proteger tus cuentas, recopilar información estratégicamente y dejar de sabotearte con el scrolleo tóxico. Tu higiene digital de emergencia para las primeras 48 horas.'
}, {
  n: 3,
  emoji: '📘',
  title: 'La Anatomía del Engaño (Días 3 y 4)',
  desc: 'Aprendé a distinguir hechos de suposiciones, a identificar los tipos de infidelidad y a detectar el Gaslighting antes de que te destruya la percepción de la realidad.'
}, {
  n: 4,
  emoji: '📙',
  title: 'La Confrontación Estratégica (Día 5)',
  desc: 'El guion exacto para la conversación más difícil de tu vida. Cómo preparar el escenario, manejar la rabia y distinguir el remordimiento real del miedo a las consecuencias.'
}, {
  n: 5,
  emoji: '📓',
  title: 'El Mapa de Decisión (Día 6)',
  desc: 'Un sistema concreto para evaluar si tu relación tiene retorno o si es momento de ejecutar una salida. Test de viabilidad, matriz de no negociables e impacto familiar incluidos.'
}, {
  n: 6,
  emoji: '📒',
  title: 'La Hoja de Ruta Final (Día 7 y Futuro)',
  desc: 'Tu plan de acción para los próximos 90 días. Protocolo de contacto cero, contrato de convivencia temporal o guía de salida digna. El primer día del resto de tu vida empieza acá.'
}];
export const tomoIncludes = ['Técnicas listas para aplicar', 'Protocolos paso a paso', 'Guiones de conversación reales', 'Checklists de implementación', 'Ejercicios de regulación emocional', 'Estrategias para decidir en frío', 'Listo para aplicar desde hoy'];
export const bonuses = [{
  n: '01',
  title: 'PROTOCOLO CERO ERRORES',
  desc: 'La guía de supervivencia para las primeras 24 horas. Qué hacer y qué evitar para no arrepentirte el resto de tu vida. Incluye checklist de acciones críticas ordenadas por urgencia real.',
  price: '$14'
}, {
  n: '02',
  title: 'GUION ANTI-HUMILLACIÓN',
  desc: 'Frases exactas para hablar sin rogar, sin explotar y sin perder el control en la conversación más difícil de tu vida. Listo para usar en el momento que más lo necesitás.',
  price: '$9'
}, {
  n: '03',
  title: 'RADAR DE DESENCADENANTES',
  desc: 'Detectá qué situaciones te disparan el dolor para frenar reacciones impulsivas antes de que te arrastren. Tu mapa personal de puntos críticos emocionales.',
  price: '$7'
}, {
  n: '04',
  title: 'APAGÁ EL INFIERNO MENTAL',
  desc: 'Un plan simple y probado para bajar la ansiedad nocturna y lograr dormir cuando tu cabeza no para. Técnicas de regulación para las noches más difíciles.',
  price: '$7'
}, {
  n: '05',
  title: 'DECISIÓN EN FRÍO',
  desc: 'Preguntas clave y ejercicios rápidos para pensar con claridad antes de tomar la decisión más importante de tu vida. Porque decidir desde el caos es el mayor error que podés cometer.',
  price: '$5'
}];